// ACTIONS PROCESSOR
// chunks through the store actions array and handles
/* global vueapp _*/

// import app from "./feathers.js";
const { app } = require('./feathers.js');
import router from "./routes.js";
import store from "./store";
import { clearAuthFeedback, setAuthFeedback } from "./authFeedback";
import { EventBus } from "./eventBus";
import Vue from "vue";
// import ClipboardJS from "clipboard";
import VueCookie from "vue-js-cookie";
import VueScrollTo from "vue-scrollto";
Vue.use(VueCookie);

// const errors = require('@feathersjs/errors')
// import _ from 'lodash'

// QUEUE passed actions then run one
//TODO this is redundant, call store diectly
const queue = function(actions) {
  store.dispatch("ACTIONS_QUEUE", actions);
};

function threadIdFrom(actionOrId) {
  if (actionOrId && typeof actionOrId === 'object') {
    return actionOrId.idThread || null;
  }
  if (typeof actionOrId === 'string' || typeof actionOrId === 'number') {
    return actionOrId;
  }
  return null;
}

// PROCESS's the next action.
// Callers pass either an action object or the raw thread id used by the error handler.
const process = function(actionOrId) {
  const idThread = threadIdFrom(actionOrId);
  // legacy support
  if (window._debugActions) {
    console.log('[actionsProcessor.process] Called', { idThread });
  }
  store.dispatch("ACTIONS_DO", {idThread: idThread})
};

// Dispatches an action
const dispatchAction = async function(action) {
  // run any functions that are not function actions before calling the action
  if (action.function && action.action != "function") {
    await action_function(action); // note, functions can mutate the action still
  }
  switch (action.action) {
    case "showModal":
      EventBus.$emit("showModal", action.options);
      Vue.nextTick(() => process(action));
      break;

    case "hideModal":
      EventBus.$emit("hideModal", action.options);
      // Vue.nextTick(process())
      break;

    case "showCardModal":
      store.dispatch("ADD_WINDOW", action);
      break;

    case "hideCardModal":
      EventBus.$emit("hideCardModal", action.options);
      break;
      
    case "function":
      await action_function(action);
      process(action);
      break;

    case "showAlert":
      EventBus.$emit("toaster", action.options);
      Vue.nextTick(process(action));
      break;

    case "path":
      if (await action_path(action)) {
        Vue.nextTick(process(action));
      }
      break;

    case "runUtilityHook":
      if (window._debugActions) {
        console.log('[actionsProcessor] runUtilityHook START', { idThread: action.idThread, action: action.action });
      }
      await action_runUtilityHook(action);
      if (window._debugActions) {
        console.log('[actionsProcessor] runUtilityHook COMPLETE, calling process', { idThread: action.idThread });
      }
      Vue.nextTick(process(action));
      break;

    case "cookie":
      action_cookie(action);
      Vue.nextTick(process(action));
      break;

    case "runOnCompleteHook":
      action_runOnCompleteHook(action);
      break;

    case "clipboard":
      action_clipboard(action);
      Vue.nextTick(process(action));
      break;

    case "showStripeCheckout":
      action_showStripeCheckout(action);
      Vue.nextTick(process(action));
      break;

    case "validate":
      action_validate(action);
      break;

    case "scrollTo":
      action_scrollTo(action);
      Vue.nextTick(process(action));
      break;

    case "throttle":
    case "debounce":
      action_debounceThrottle(action);
      Vue.nextTick(process(action));
      break;

    case "setFocus":
      setTimeout(() => Vue.nextTick(action_setFocus(action)), 400);
      // Vue.nextTick(action_setFocus(action))
      Vue.nextTick(process(action));
      break;

    case "wait":
      action_wait(action);
      break;

    case "authLogin":
    case "authLogout":
      
    case "authRegister":
    case "authMagicRequest":
    case "authInviteComplete":
    case "authForgot":
    case "authReset":
      
    case "authResend":
    case "authResendVerify":
    case "authVerify":
      action_auth(action);
      break;

    case "mapInfoWindow":
      EventBus.$emit(action.action, action);
      Vue.nextTick(process(action));
      break;

    case "emit":
      EventBus.$emit(action.options.eventName, action.options.message);
      Vue.nextTick(process(action));
      break;
      
    case "messageSend":
      action_message(action, false);
      Vue.nextTick(process(action));
      break;
      
  case "messageSendAnonChannel":
      action_message(action, true);
      Vue.nextTick(process(action));
      break;
      
    case "channelJoinAnon":
      if (await action_channelJoinAnonymous(action)) {
        Vue.nextTick(() => process(action));
      }
      break;
      
    case "channelLeaveAnon":
      action_channelLeaveAnonymous(action);
      Vue.nextTick(process(action));
      break;
    
    case "oauthLoginHook":
    case "authLoginOauth":
      action_authLoginOauth(action);
      break;
      
    case "consoleError":
      action_consoleError(action);
      break;
      
    case "pwaCustomInstall":
      action_pwaCustomInstall(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPromptInstall":
      action_pwaPromptInstall(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPushNotificationSend":
      action_pwaPushNotificationSend(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPromptPushPermission":
      action_pwaPromptPushPermission(action);
      Vue.nextTick(process(action));
      break;

    case "llmToolCall":
      action_llmToolCall(action);
      Vue.nextTick(process(action));
      break;

    case "llmToolCallResponse":
      action_llmToolCallResponse(action);
      Vue.nextTick(process(action));
      break;

    case "llmQueryStop":
      action_llmQueryStop(action);
      Vue.nextTick(process(action));
      break;

    case "assistantStop":
      action_assistantStop(action);
      Vue.nextTick(process(action));
      break;

    case "":
    case "namedAction":
    case null:
    case undefined:
      // EventBus.$emit("processNamedAction", action);
      action_namedAction(action);
      break;

    default:
    action.idThread ? store.commit('SET_PENDINGTRHEADS', action.idThread) : null
    BF.errorThrow (10112, `No action handler found for this action ${action.action}` , action)
  }
};

const action_namedAction = function(action) {
  const name = action.name || (action.options && action.options.name);
  const options = action.options || {};
  const idThread = action.idThread || Date.now();

  // Find the active window (fallback to first window)
  const idActiveWindow = store.state.wndw.idWndwActive;
  const targetWindow = (store.state.wndw.windows || []).find(w => w.id === idActiveWindow) || (store.state.wndw.windows && store.state.wndw.windows[0]) || null;

  // 1) Try form-level namedActions on the active window
  let actionsObj;
  if (targetWindow && targetWindow.formSchema && targetWindow.formSchema.form) {
    actionsObj = _.get(targetWindow, ['formSchema', 'form', 'namedActions', name]);
  }

  // 2) Fallback to site/component registry
  actionsObj = actionsObj || store.getters.getSiteNamedAction(name);

  // If still not found, preserve legacy behavior: emit to EventBus so component listeners receive it
  if (!actionsObj) {
    EventBus.$emit("processNamedAction", action);
    return;
  }

  // Normalize to array and clone
  const actionsArray = Array.isArray(actionsObj) ? _.cloneDeep(actionsObj) : [_.cloneDeep(actionsObj)];
  const idForm = targetWindow && targetWindow.formSchema && targetWindow.formSchema.id ? targetWindow.formSchema.id : '';

  // Mix in provided options and thread/form metadata
  actionsArray.forEach(a => {
    a.options = Object.assign({}, a.options || {}, options);
    a.idThread = idThread;
    a.idForm = a.idForm || idForm;
  });

  // Enqueue resolved actions (insert preserves intended ordering for namedAction callers)
  store.dispatch('ACTIONS_QUEUE', { actions: actionsArray, insert: true, idThread: idThread, idForm: idForm });
};

const action_pwaPromptPushPermission = async function (action) {
  if ('Notification' in window && 'PushManager' in window) {
    Notification.requestPermission().then(function(permission) {
      if (permission === 'granted') {
        const {pushDataGetKey, pushDataRegister} = require('./feathers.js');
        return window.registerSW .pushManager.getSubscription()
          .then(async (subscription) => {
            if(subscription) {
              return subscription;
            }
            const vapidPublicKey = await pushDataGetKey.find();
            
            return window.registerSW.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: vapidPublicKey
            });
          })
          .then(subscription => {
            pushDataRegister.create({
                subscription: subscription,
                options: action.options
              });
          })
          .catch(e => {
            console.log('Error saving subscription to server.\n', e)
            BF.errorThrow(e);
          });
      }
    });
  }
  else {
    alert('Browser does not support push notifications.');
  }
};

const action_pwaPushNotificationSend = async function (action) {
  const {pushNotificationSend} = require('./feathers.js');
  
  try {
    var options = Object.assign({}, action.options);
    
    delete options.actions;
    options.actions = action.options.actionButtons;
    // console.log('@action_pwaPushNotificationSend options: ', options)
    delete options.actionButtons;
    
    var result = await pushNotificationSend.create(options);
    console.log('@pwaPushNotificationSend result: ', result)
  }
  catch (e) {
    BF.errorThrow(e)
  }
};

const action_pwaPromptInstall = function (action) {
  window.deferredPrompt.prompt();

  window.deferredPrompt.userChoice.then( choiceResult => {
    //check to change onAccepted_actions
    if (choiceResult.outcome === 'accepted') {
      action?.options?.onAccepted ? action.options.onAccepted() : null;
    } else {
      action?.options?.onDismissed ? action.options.onDismissed() : null;
    }
    window.deferredPrompt = null;
  });
};

//Create new action that will block default prompt and set new custom prompt
//save deferredPrompt to window so it can be used globally
const action_pwaCustomInstall = function (action) {
  console.log();
  window.addEventListener('beforeinstallprompt', e => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    window.deferredPrompt = e;
    action?.options?.beforeinstallprompt ? action.options.beforeinstallprompt() : null;
  });
};

const action_consoleError = function (action) {
  console.error(action.options.message);
};

const action_authLoginOauth = function (action) {
  const getQueryParams = require("Js/bfUtilities").getQueryParams;
  try {
      getQueryParams().oauthtoken ? window.localStorage.setItem('feathers-jwt', getQueryParams().oauthtoken) : null;
  } catch (e) {
      console.log('Error setting JWT, due to insuficient storage. Removing cached "formSchemas" to store JWT.');
      if (getQueryParams().oauthtoken) {
        handleBfSite();
      }
  }
  
  var oauthErrorMessage = getQueryParams().errorMessage;
  if (oauthErrorMessage) {
    if (oauthErrorMessage.includes('account disabled')) {
      BF.errorThrow(10163, oauthErrorMessage, 'OAuth on login hook error.');
    }
    else {
      BF.errorThrow(10160, oauthErrorMessage, 'OAuth on login hook error.');
    }
  }
  setTimeout(() => {
    if (window.localStorage.getItem('feathers-jwt')) {
        store.dispatch("ONLOGINHOOK", {action})
        .then(result => {
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread)
          BF.errorThrow (10158, error.message , 'OAuth on login hook error.');
        });
    }
  }, 200);
};

const action_channelLeaveAnonymous = function (action) {
  const messageRemoveUserService = app.service('message/removeuser');
  
  //Treat error properly
  if (!("channel" in action.options)) {
    BF.errorThrow (10130, 'Missing channel' , action.options)
  }
  
  messageRemoveUserService.create({channel: action.options.channel, anonymous: true, users: []});
};

const action_channelJoinAnonymous = async function (action) {
  const messageAddUserService = app.service('message/adduser');
  
  //Treat error properly
  if (!("channel" in action.options)) {
    BF.errorThrow (10130, 'Missing channel' , action.options)
    return false;
  }
  
  try {
    await messageAddUserService.create({channel: action.options.channel, anonymous: true, users: []});
    return true;
  } catch (error) {
    BF.errorThrow(10132, error.message, 'Join channel error.');
    return false;
  }
};

const action_message = function (action, anonymousChannel) {
  const messageService = app.service('messages');
  
  if (!store.getters.isOnline()) {BF.errorThrow(10902, 'User has no internet connection', 'Offline')}
  
  if (!Array.isArray(action.options.channels)) {
    BF.errorThrow (10131, 'Channels need to be an array' , action.options.channels);
    return;
  }

  const message = {
      channels: action.options.channels,
      actions: action.options.actions,
      model: action.options.model,
      app: action.options.app
    };
    
  messageService.create({message: message, anonymousChannel: anonymousChannel})
  .catch(error => {
    if (anonymousChannel) {
      BF.errorThrow(10133, error.message, 'Anonymous send error.');
      return;
    }
    BF.errorThrow (10132, error.message , 'Send message error.');
  });
};

const action_runUtilityHook = async function(action) {
  return new Promise((resolve, reject) => {
    EventBus.$emit("runUtilityHook", action, function(result) {
      // console.log('@callback runUtilityHook results: ', result.results)
      resolve(result);
    });
  }).catch(error => {
    console.error('Error in runUtilityHook:', error);
    throw error; // Re-throw to be handled by the await
  });
};

const action_runOnCompleteHook = function(action) {
  return new Promise((resolve, reject) => {
    EventBus.$emit("runOnCompleteHook", action, function(result) {
      // console.log('@action_runOnCompleteHook callback', result.results)
      resolve(result);
    });
  }).then(() => {
    // Only process the next action after the hook completes
    Vue.nextTick(process(action));
  }).catch(error => {
    console.error('Error in runOnCompleteHook:', error);
    // Still process next action even if there's an error
    Vue.nextTick(process(action));
  });
};

const action_validate = function(action) {
  EventBus.$emit("validate", action);
};

const action_wait = function(action) {
  setTimeout(() => Vue.nextTick(process(action)), action.options.ms);
};

const action_showStripeCheckout = function(action) {
  EventBus.$emit("showStripeCheckout_" + action.options.formId, action);
};

const action_path = async function(action) {
  store.commit('SET_PENDINGTRHEADS', action.idThread);
  action.options = Object.assign(action.options, action.options.options); // map any additional options
  delete action.options.options; // not needed but may in future
  
  // Is targeted to a window
  if (action.options.windowName) {
    store.commit("updateWindow", action.options);
    return true;
  }
  // is PATH
  else if (action.options.path) {
    try {
      await router.push(action.options.path);
      return true;
    } catch (e) {
      store.commit('SET_PENDINGTRHEADS', action.idThread);
      BF.errorThrow(10141, 'Path action error, duplicated navigation blocked', 'Path action error, trying to navigate to current page');
      return true;
    }
  }
  // is REDIRECT
  else if (action.options.url) {
    if (action.options.sameWindow) {
      window.location = action.options.url;
      return false;
    } else {
      //default to new tab
      // window.open(action.options.url, "_blank");
      window.open(action.options.url, action.options.name || "_blank", action.options.features);
      return true;
    }
  } else {
    BF.errorThrow(10140, 'Path action error, path or url is empty ....', 'Path action error, missing path');
    return true;
  }
};

const action_clipboard = function(action) {
  EventBus.$emit("doClipboard", action, function(result) {});
};

const action_setFocus = function(action) {
  action.options.select
    ? document.querySelector("[id^=" + action.options.elementId + "]").select()
    : document.querySelector("[id^=" + action.options.elementId + "]").focus(); // starts with ...
};

const action_cookie = function(action) {
  let result = Vue.cookie[action.options.action](
    action.options.name,
    action.options.value,
    action.options.daysOrOptions
  );
  BF.socketDisconnect()
  BF.socketConnect()
};

const action_scrollTo = function(action) {
  var cancelScroll = VueScrollTo.scrollTo(
    action.options.element,
    action.options.duration,
    action.options.options
  );
};

const action_function = async function(action) {
  // Check if there are any executeFunction listeners (component-level handlers)
  const hasListeners = EventBus && EventBus._events && EventBus._events.executeFunction && EventBus._events.executeFunction.length;
  
  if (hasListeners) {
    // Primary path: use EventBus with callback Promise pattern
    return new Promise((resolve, reject) => {
      EventBus.$emit("executeFunction", action, function(result) {
        resolve(result);
      });
    }).catch(error => {
      console.error('Error in executeFunction:', error);
      throw error;
    });
  }

  // Fallback path: execute centrally when no listeners exist (page transition edge case)
  try {
    if (!action || !action.function) return;

    // Resolve formSchema from idWndw or idForm if available
    let formSchema = {};
    if (action.idWndw) {
      formSchema = store.getters.getFormSchema(action.idWndw) || {};
    } else if (action.idForm) {
      const wnd = (store.state.wndw.windows || []).find(w => (w.formSchema && w.formSchema.id) === action.idForm);
      formSchema = wnd ? wnd.formSchema : {};
    } else {
      // Use active window if no specific window is specified
      const activeWnd = (store.state.wndw.windows || []).find(w => w.id === store.state.wndw.idWndwActive);
      formSchema = activeWnd ? activeWnd.formSchema : {};
    }

    const model = formSchema.model || {};
    const params1 = store.state.site.content.params || {};
    const app1 = (store.state.site && store.state.site.content && store.state.site.content.app) ? store.state.site.content.app : {};
    const args = action.options && action.options.args ? action.options.args : undefined;
    const schema = action.schema || {};  // Component schema (if dispatched from bfcomponent)

    // Execute action.function as an async function (same signature formGen uses)
    // Ensure the provided function body terminates cleanly even if it ends with a trailing comment
    const functionBody = `${action.function}\n`;
    const funct = new Function(
      'formSchema', 'model', 'action', 'app', 'params', 'args', 'EventBus', 'schema',
      `return (async function(formSchema, model, action, app, params, args, EventBus, schema) { ${functionBody} })(formSchema, model, action, app, params, args, EventBus, schema);`
    );

    await funct(formSchema, model, action, app1, params1, args, EventBus, schema);

    // Best-effort: rebuild reactivity if available
    if (BF.rebuildReactivity) {
      BF.rebuildReactivity(model);
    }

  } catch (e) {
    BF.errorThrow(e);
    throw e;
  }
};

const action_auth = function(action) {
  const idActiveWindow = store.state.wndw.idWndwActive;
  const targetWindow = store.state.wndw.windows.find(window => window.id === idActiveWindow);
  var model = targetWindow.formSchema.model;
  var email = model?.email?.toLowerCase();
  var password = model.password;
  var token = model.token;
  clearAuthFeedback(formGen.formSchema.model);
  switch (action.action) {
    case "authLogin":
        token =
          model.token ||
          vueapp.$route.params.token ||
          vueapp.$route.params.optionalSlug ||
          vueapp.$route.query.token;
        authLogin({email, password, token, action})
        .catch(e => {
          if (e.message.includes("Setting the value of 'feathers-jwt' exceeded the quota")) {
            console.log('Error setting JWT, due to insuficient storage. Removing cached "formSchemas" to store JWT.');
            handleBfSite();
            
            authLogin({email, password, token, action})
            .catch(e => throwLoginError(e && e.message, 'Invalid login attempt.'));
          }
          else {
            store.commit('SET_PENDINGTRHEADS', action.idThread);
            throwLoginError(e && e.message, 'Invalid login attempt.');
          }
        });
      break;

    case "authLogout":
      store
        .dispatch("LOGOUT", {action})
        .then(result => {
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10151, error.message, 'Logout error.');
        });
      break;

    case "authRegister": {
      // Same payload ONREGISTERHOOK sends, minus user: the server adds the created record.
      const registration = _.cloneDeep(formGen.formSchema);
      if (registration.model) {
        delete registration.model.password;
        delete registration.model.password2;
      }
      if (registration.form) {
        delete registration.form.hookSetName; // else fm script captures incorrectly
      }
      registration.query = require("Js/bfUtilities").getQueryParams();
      store
        .dispatch("SIGNUP", {
          email: email,
          password: password,
          registration
        })
        .then(result => {
          const { _registrationHook: registrationHook, ...user } = result;
          delete formGen.formSchema.model.password;
          delete formGen.formSchema.model.password2;
          var payload = _.cloneDeep(formGen.formSchema);
          delete payload.form.hookSetName; // else fm script captures incorrectly
          payload.user = user;
          store.dispatch("ONREGISTERHOOK", {payload, action, registrationHook});
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10152, error.message, 'Signup error.');
        });
      break;
    }

    case "authForgot":
      store
        .dispatch("ONPWRESETHOOK", {email, action})
        .then(result => {
          setAuthFeedback(formGen.formSchema.model, {
            code: "auth.reset_link_sent",
            message: "Check your email for a reset link",
            type: "info"
          });
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10153, error.message, 'Password reset hook error.');
        });
      break;

    case "authMagicRequest":
      store
        .dispatch("MAGIC_REQUEST", {email, action})
        .then(() => {
          setAuthFeedback(formGen.formSchema.model, {
            code: "auth.magic_link_sent",
            message: "Check your email for a magic link",
            type: "info"
          });
          Vue.nextTick(() => process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10161, error.message, 'Magic link request error.');
        });
      break;

    case "authInviteComplete":
      token =
        formGen.formSchema.model.token ||
        vueapp.$route.params.token ||
        vueapp.$route.params.optionalSlug ||
        vueapp.$route.query.token;
      var signIn = action.options && action.options.signIn === true;
      store
        .dispatch("INVITE_COMPLETE", { token, password, signIn, action })
        .then(result => {
          delete formGen.formSchema.model.password;
          delete formGen.formSchema.model.password2;
          if (signIn && result && result.accessToken) {
            store.commit("LOGIN_SUCCESS", result);
            store.dispatch("ONLOGINHOOK", { action });
          }
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10162, error.message, 'Invite complete error.');
        });
      break;

    case "authReset":
      token =
        formGen.formSchema.model.token || vueapp.$route.params.optionalSlug || vueapp.$route.query.token;
      store
        .dispatch("RESETPW", { token, password, action })
        .then(result => {
          delete formGen.formSchema.model.password;
          delete formGen.formSchema.model.password2;
          setAuthFeedback(formGen.formSchema.model, {
            code: "auth.password_reset_success",
            message: "Your password has been reset successfully!",
            type: "success"
          });
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10154, error.message, 'Password reset error.');
        });
      break;

    case "authResendVerify":
    case "authResend":
      store
        .dispatch("RESENDVERIFYSIGNUP", {email, action})
        .then(result => {
          setAuthFeedback(formGen.formSchema.model, {
            code: "auth.verify_link_sent",
            message: "Check your email for a verification link",
            type: "info"
          });
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10155, error.message, 'Resend verify signup error.');
        });
      break;
      
    case "authVerify":
      token =
        formGen.formSchema.model.token || vueapp.$route.params.optionalSlug || vueapp.$route.query.token;
      store
        .dispatch("VERIFYSIGNUP", { token, action })
        .then(result => {
          setAuthFeedback(formGen.formSchema.model, {
            code: "auth.email_verified",
            message: "Email Verified",
            type: "success"
          });
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10156, error.message, 'Verify signup error.');
        });
      break;

  }
};

var debounceThrottle = {};
const action_debounceThrottle = function(action) {
  
  let namedAction = action.options.namedAction, currentThread = action.idThread;
  let remainingSameThread;
  if (!namedAction) {
    let splitArray = _.partition(vueapp.$store.state.actions.actions, {idThread: currentThread})
    remainingSameThread = splitArray[0];
    
    vueapp.$store.dispatch('ACTIONS_CLEAR', action)
  }
  else {
    remainingSameThread = [{action: 'namedAction', name: namedAction}]
  }
  
  //conitnue code below
  
  const callback = function () {
    store.dispatch("ACTIONS_QUEUE", {actions: remainingSameThread, idThread: action.idThread});
  };
  
  let name = action.options.name || 'bfdebounce';
  if (!debounceThrottle[name]) {
     debounceThrottle[name] = _[action.action](callback,
      action.options.wait,
      action.options
     );
  }
  
  debounceThrottle[name]()

};

function throwLoginError(message, description) {
  if (typeof message === 'string' && message.includes('account disabled')) {
    BF.errorThrow(10163, message, description);
    return;
  }
  BF.errorThrow(10150, message, description);
}

async function authLogin (params) {
  var email = params.email, password = params.password, token = params.token, action = params.action;
  return new Promise((resolve, reject) => { store
    .dispatch("LOGIN", {
      email,
      password,
      token
    })
    .then(result => {
      delete formGen.formSchema.model.password;
      store.dispatch("ONLOGINHOOK", {action})
      .then(result => {
        // Vue.nextTick(process(action));
        resolve();
      })
      .catch(error => {
        store.commit('SET_PENDINGTRHEADS', action.idThread);
        BF.errorThrow(10157, error.message, 'On login hook error.');
      });
    })
    .catch(error => {
      // BF.errorThrow(10150, error.message, 'Invalid login attempt.', action.idThread);
      if (error.message.includes("Setting the value of 'feathers-jwt' exceeded the quota")) {
        reject(error);
      }
      else {
        store.commit('SET_PENDINGTRHEADS', action.idThread);
        throwLoginError(error && error.message, 'Invalid login attempt.');
        reject(error);
      }
    });
    });
}

function handleBfSite () {
  var currentBfSiteObj = readBfSiteCache();
  
  if (!currentBfSiteObj || !currentBfSiteObj.siteJSON || !currentBfSiteObj.siteJSON.content || !currentBfSiteObj.siteJSON.content.layouts) {
    return false;
  }

  var updateBfSite = false;
  for (var key in currentBfSiteObj.siteJSON.content.layouts) {
    if ((key !== 'error') && currentBfSiteObj.siteJSON.content.layouts[key].hasOwnProperty('formSchema')) {
      delete currentBfSiteObj.siteJSON.content.layouts[key].formSchema;
      updateBfSite = true;
    }
  }
  if (updateBfSite) {
    try {
      window.localStorage.removeItem('_bfsite');
      let stringifiedObj = JSON.stringify(currentBfSiteObj);
      window.localStorage.setItem('_bfsite', stringifiedObj);
    } catch (e) {
      BF.errorThrow (10171, `Unable to update '_bfsite' in local storage.`, 'Error encountered while attempting to write data to local or session storage.');
    }
  }
  return updateBfSite;
}

function readBfSiteCache () {
  try {
    var raw = window.localStorage.getItem('_bfsite');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

const action_llmToolCall = async function(action) {
  console.log('[LLM Tool Call] Processing frontend tool execution:', action.options);
  
  try {
    const { functions, toolCallId } = action.options;
    try { console.warn('[BF/FE] llmToolCall received', { toolCallId, names: Array.isArray(functions) ? functions.map(f=>f && f.name) : [] }); } catch (_) {}
    
    if (!functions || !Array.isArray(functions)) {
      throw new Error('Invalid functions array provided to llmToolCall');
    }
    
    if (!toolCallId) {
      throw new Error('toolCallId is required for llmToolCall');
    }
    
    console.log(`[LLM Tool Call] Processing ${functions.length} function(s) for toolCallId: ${toolCallId}`);
    
    // Process each function (for now, we'll handle them sequentially)
    for (const func of functions) {
      console.log(`[LLM Tool Call] Executing function: ${func.name}`);
      
      const actionName = func.name;
      
      // Parse function arguments
      let args = {};
      try {
        args = typeof func.arguments === 'string' ? JSON.parse(func.arguments) : func.arguments;
      } catch (e) {
        console.warn('[LLM Tool Call] Failed to parse function arguments:', func.arguments);
        args = {};
      }
      
      console.log(`[LLM Tool Call] Mapped ${func.name} -> ${actionName} with args:`, args);
      
      // Inject toolCallId into options for the namedAction chain
      const namedActionOptions = {
        ...args,
        toolCallId: toolCallId  // Inject toolCallId for response action
      };
      
      try {
        // Execute the BetterForms namedAction with injected toolCallId
        try { console.warn('[BF/FE] dispatching namedAction', { actionName, toolCallId }); } catch (_) {}
        EventBus.$emit("processNamedAction", {
          action: "namedAction",
          name: actionName,
          options: namedActionOptions
        });
        try { console.warn('[BF/FE] namedAction emitted', { actionName }); } catch (_) {}
        
        console.log(`[LLM Tool Call] Successfully triggered ${func.name} with toolCallId injected`);
        
      } catch (error) {
        console.error(`[LLM Tool Call] Error executing ${func.name}:`, error);
        
        // Send error response immediately if namedAction fails
    await app.service('llm/tool-response').create({
          toolCallId: toolCallId,
          result: {
            success: false,
            error: `Failed to execute ${func.name}: ${error.message}`,
            timestamp: new Date().toISOString()
          }
        });
      }
    }
    
    console.log(`[LLM Tool Call] All functions triggered. Response will be sent by llmToolCallResponse action.`);
    
  } catch (error) {
    console.error('[LLM Tool Call] Error in action_llmToolCall:', error);
    
    // Try to send error response if we have toolCallId
    if (action.options?.toolCallId) {
      try {
    await app.service('llm/tool-response').create({
          toolCallId: action.options.toolCallId,
          result: {
            success: false,
            error: error.message,
            timestamp: new Date().toISOString()
          }
        });
      } catch (responseError) {
        console.error('[LLM Tool Call] Failed to send error response:', responseError);
      }
    }
    
    // Throw the error so action system knows it failed
    BF.errorThrow(10300, error.message, 'LLM Tool Call execution failed');
  }
};

const action_llmToolCallResponse = async function(action) {
  
  try {
    // Get toolCallId from action options (mixed in by action processor from namedAction)
    const toolCallId = action.options?.toolCallId;
    
    if (!toolCallId) {
      console.error('[LLM Tool Call Response] No toolCallId found in action options');
      throw new Error('No toolCallId found in action options. Make sure this action is part of a namedAction triggered by llmToolCall.');
    }
    
    // Get custom response data from action options (user-defined, excluding toolCallId)
    const { toolCallId: _, ...responseData } = action.options || {};
  
    
    // Import FeathersJS service for sending response
    
    // Send response back to LLM Query service via FeathersJS
    await app.service('llm/tool-response').create({
      toolCallId: toolCallId,
      result: {
        success: true,
        ...responseData,  // User's custom response data
        timestamp: new Date().toISOString()
      }
    });
    
    
  } catch (error) {
    console.error('[LLM Tool Call Response] Error in action_llmToolCallResponse:', error);
    
    // Try to send error response if we have toolCallId
    const toolCallId = action.options?.toolCallId;
    if (toolCallId) {
      try {
    await app.service('llm/tool-response').create({
          toolCallId: toolCallId,
          result: {
            success: false,
            error: error.message,
            timestamp: new Date().toISOString()
          }
        });
        
      } catch (responseError) {
        console.error('[LLM Tool Call Response] Failed to send error response:', responseError);
      }
    }
    
    // Throw the error so action system knows it failed
    BF.errorThrow(10301, error.message, 'LLM Tool Call Response failed');
  }
};

const action_llmQueryStop = async function(action) {
  console.log('[LLM Query Stop] Processing stop request:', action.options);
  
  try {
    const { streamId, apiKey } = action.options;
    
    if (!streamId) {
      console.warn('[LLM Query Stop] No streamId provided. This is normal if no stream is active.');
      return;
    }

    // Import FeathersJS service
    
    // Call the stop service (consistent with llm/query service)
    await app.service('llm/query/stop').create({ streamId, apiKey });
    
    console.log(`[LLM Query Stop] Successfully requested stop for stream: ${streamId}`);
    
  } catch (error) {
    // Graceful handling - stream might already be done or invalid
    console.log(`[LLM Query Stop] Stop request for stream ${action.options?.streamId} completed or failed gracefully.`);
  }
};


const action_assistantStop = async function(action) {
  console.log('[Assistant Stop] Processing stop request:', action.options);

  try {
    const { threadId, runId } = action.options || {};

    if (!threadId || !runId) {
      console.warn('[Assistant Stop] Missing threadId or runId. Cannot stop assistant stream.');
      return;
    }

    // Import FeathersJS service

    // Call the stop service
    await app.service('stream/create/assistants/stop').create({ threadId, runId });

    console.log(`[Assistant Stop] Successfully requested stop for thread: ${threadId}, run: ${runId}`);

  } catch (error) {
    // Graceful handling
    console.log(`[Assistant Stop] Stop request completed or failed gracefully.`);
  }
};


export const actions = {
  process: process,
  queue: queue,
  dispatchAction: dispatchAction
};
